import { render, staticRenderFns } from "./CarHealthIssuesHeader.vue?vue&type=template&id=4c441bf7&"
import script from "./CarHealthIssuesHeader.vue?vue&type=script&lang=ts&"
export * from "./CarHealthIssuesHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports